import React from 'react';
import useWebsiteAgreement from './useWebsiteAgreement';
import Agreement from './Agreement';
import WebsiteAgreementDeclined from './WebsiteAgreementDeclined';

function WebsiteAgreement() {
  const {
    isSavingResponse,
    savingResponseError,
    handleAgree,
    showDeclineScreen,
    navigateToDeclined,
    navigateToAgreement,
  } = useWebsiteAgreement();

  if (showDeclineScreen) {
    return (
      <WebsiteAgreementDeclined
        navigateToAgreement={navigateToAgreement}
      />
    );
  }

  return (
    <Agreement
      isSavingResponse={isSavingResponse}
      savingResponseError={savingResponseError}
      onAgree={handleAgree}
      navigateToDeclined={navigateToDeclined}
    />
  );
}

export default WebsiteAgreement;
